"use client";

import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { AlertTriangle, Trash2 } from "lucide-react";
import { useTranslation } from "react-i18next";

interface CancelDeleteDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  variant: "cancel" | "delete";
  isLoading?: boolean;
  onConfirm: () => void;
}

export function CancelDeleteDialog({
  open,
  onOpenChange,
  variant,
  isLoading = false,
  onConfirm,
}: CancelDeleteDialogProps) {
  const { t } = useTranslation();

  const isCancel = variant === "cancel";

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-[425px]">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            {isCancel ? (
              <AlertTriangle className="h-5 w-5 text-amber-500" />
            ) : (
              <Trash2 className="h-5 w-5 text-destructive" />
            )}
            {isCancel ? t("videoList.cancelTitle") : t("videoList.deleteTitle")}
          </DialogTitle>
          <DialogDescription>
            {isCancel
              ? t("videoList.cancelDescription")
              : t("videoList.deleteDescription")}
          </DialogDescription>
        </DialogHeader>
        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)} disabled={isLoading}>
            {t("common.cancel")}
          </Button>
          <Button
            variant={isCancel ? "default" : "destructive"}
            onClick={onConfirm}
            disabled={isLoading}
          >
            {isLoading
              ? t("videoList.processing")
              : isCancel
              ? t("videoList.cancelButton")
              : t("videoList.deleteButton")}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}